import { useApiClient } from '@/app/core/api-client';
import type { Guard } from './interfaces';

export const notAuthGuard: Guard = () => {
  return useApiClient().auth.isAuthenticated() ? '/' : true;
};
